import { Link } from 'react-router-dom'
import SiteFooter from '../components/SiteFooter.jsx'

export default function PrivacyPage() {
  return (
    <>
      <main id="main-content">
        <section className="page-hero" data-reveal aria-labelledby="page-title">
          <span className="eyebrow">Privacy library</span>
          <h1 id="page-title">
            Privacy, in <em>plain language</em>.
          </h1>
          <p>
            Choose a product or website below to see what information it handles, why it is
            used, and how to make a privacy or deletion request.
          </p>
        </section>

        <section className="section" aria-label="Available privacy policies">
          <div className="policy-grid">
            <Link className="policy-card" data-reveal to="/privacy/academic-edge/">
              <span className="status-chip">iOS application · 13+</span>
              <h2>Academic Edge</h2>
              <p>
                Accounts, planning information, optional device permissions, file storage,
                shared spaces, and AI-assisted features.
              </p>
              <span className="text-link">Read the policy</span>
            </Link>
            <Link className="policy-card" data-reveal data-reveal-delay="0.08" to="/privacy/edgezpace/">
              <span className="status-chip">Public website</span>
              <h2>Edgezpace</h2>
              <p>
                Email correspondence, website delivery and security information, external
                links, and service providers.
              </p>
              <span className="text-link">Read the policy</span>
            </Link>
          </div>

          <div className="contact-panel" data-reveal>
            <div>
              <h2>Questions or deletion requests</h2>
              <p>
                Contact the studio from the email address associated with your account whenever
                possible.
              </p>
            </div>
            <a href="mailto:info@edgezpace.com">info@edgezpace.com</a>
          </div>
        </section>
      </main>

      <SiteFooter note="Privacy information for current public sites and applications." />
    </>
  )
}
